<ul class="nav nav-tabs flex-shrink-0 bg-body text-body position-relative">
    <ng-content></ng-content>
</ul>
